<template>
    <painel-component :items="itemsOne">

        <form v-if="showLoader">
            <row-component>
                <row-col-component class-row-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                    <label>Cliente:</label>
                    <Multiselect disabled label="name" v-model="formData.client_id" :searchable="true"
                                 :options="selectClientList" :noOptionsText="noOptionsText"
                                 :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                    <label>Status:</label>
                    <Multiselect disabled v-model="formData.status" :searchable="true" :options="selectActiveInative"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12">
                    <label>Logs:</label>
                    <Multiselect disabled v-model="formData.logs" :searchable="true" :options="selectYesNo"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component
                        :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                    <label>Pasta:</label>
                    <div class="position-relative w-100" style="height: 43px">
                        <i class="ms-1 folder icon h-auto position-absolute top-50 start-0 translate-middle-y"></i>
                        <input-component disabled class="ps-4" type-input="text" v-model="formData.uuid"/>
                    </div>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <label>Quantidade de Usuários:</label>
                    <input-component disabled type-input="number" v-model="formData.quant_user"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <label>Quantidade GB:</label>
                    <input-component disabled type-input="number" v-model="formData.quant_storage"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <label>Quantidade Player:</label>
                    <input-component disabled type-input="number" v-model="formData.quant_player"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component class-row-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <label>Compactar Imagem:</label>
                    <Multiselect disabled v-model="formData.compress_img" :searchable="true" :options="selectYesNo"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                    <label>Compactar Video:</label>
                    <Multiselect disabled v-model="formData.compress_video" :searchable="true" :options="selectYesNo"
                                 :noOptionsText="noOptionsText" :noResultsText="noResultsText"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <label>Tempo de imagem (Segundos):</label>
                    <input-component disabled type-input="number" v-model="formData.time_img"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <label>Tempo de imagem (Sindico):</label>
                    <input-component disabled type-input="number" v-model="formData.time_img_trustee"/>
                </row-col-component>

                <row-col-component class-row-col="col-xxl-4 col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
                    <label>Tempo HTML (Sindico):</label>
                    <input-component disabled type-input="number" v-model="formData.time_html_trustee"/>
                </row-col-component>
            </row-component>

            <row-component>
                <row-col-component class-row-col="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <button-route class="w-100" :items="itemsTwo"/>
                </row-col-component>
            </row-component>
        </form>
    </painel-component>
</template>

<script>
import PainelComponent from "@/components/dashboard/PainelComponent";
import RowComponent from "@/components/row/RowComponent";
import RowColComponent from "@/components/row/RowColComponent";
import Multiselect from "@vueform/multiselect";
import InputComponent from "@/components/form/InputComponent";
import ButtonRoute from "@/components/buttons/ButtonRoute";
import {useToast} from "vue-toastification";

const toast = useToast()
export default {
    name: "ReleaseAccessShow",
    components: {
        ButtonRoute,
        InputComponent,
        Multiselect,
        RowColComponent,
        RowComponent,
        PainelComponent
    },

    props: {
        id: {
            required: true
        }
    },

    created() {
        this.$store.dispatch("changeNamePage", "Liberar Acesso")
        this.$store.dispatch("loadClientList")
        this.loadItems()
        this.checkACL()
    },

    data() {
        return {
            itemsOne: {
                icon: "eye",
                title: "Ver"
            },

            itemsTwo: {
                icon: "reply all",
                name: "Voltar",
                route: "/release-access/search"
            },

            formData: {
                client_id: "",
                uuid: "",
                permissions: [],
                name: "",
                time_img: "",
                time_img_trustee: "",
                time_html_trustee: "",
                quant_user: "",
                quant_player: "",
                quant_storage: "",
                compress_img: "",
                compress_video: "",
                status: "",
                logs: ""
            },

            showLoader: false,
        }
    },

    methods: {
        loadItems() {
            this.$store.dispatch('loadReleaseAccess', this.id)
                .then((r) => {
                    this.formData = r;
                }).catch(() => {
                toast.error("Erro desconhecido !", {timeout: 1200});
            })
        },

        async checkACL() {
            this.$store.dispatch('ACLItemsNav')
                .then((r) => {
                    if (r.data.indexOf('release-access-search') !== -1) {
                        this.showLoader = true
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

        loadNameClient(id) {
            this.$store.dispatch("loadClient", id).then(r => {
                this.formData.name = r.name
            })
        },
    },

    computed: {
        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        selectClientList() {
            return this.$store.state.var.selectClientList
        },

        selectActiveInative() {
            return this.$store.state.var.selectActiveInative
        },

        selectYesNo() {
            return this.$store.state.var.selectYesNo
        },
    }
}
</script>